import { useEffect, useState } from "react";
import { IMG } from "@/lib/images";

// Cinematic "wow" arrival — plays once per session on the home page.
export default function IntroOverlay() {
  const [show, setShow] = useState(false);
  const [step, setStep] = useState(0); // 0 dark, 1 library, 2 Dorothée, 3 cat, 4 phrase
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("dl_intro_seen") === "1") return;
    const reduce = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    setShow(true);
    if (reduce) { setStep(4); return; }
    const t = [];
    t.push(setTimeout(() => setStep(1), 200));
    t.push(setTimeout(() => setStep(2), 1100));
    t.push(setTimeout(() => setStep(3), 2000));
    t.push(setTimeout(() => setStep(4), 3100));
    return () => t.forEach(clearTimeout);
  }, []);

  const dismiss = () => {
    setLeaving(true);
    sessionStorage.setItem("dl_intro_seen", "1");
    setTimeout(() => setShow(false), 900);
  };

  if (!show) return null;

  return (
    <div
      data-testid="intro-overlay"
      className="fixed inset-0 z-[100] overflow-hidden bg-[#050814] transition-opacity duration-[900ms]"
      style={{ opacity: leaving ? 0 : 1 }}
    >
      {/* Library backdrop */}
      <img
        src={IMG.heroLibrary}
        alt=""
        className="absolute inset-0 w-full h-full object-cover transition-all duration-[1600ms]"
        style={{ opacity: step >= 1 ? 0.6 : 0, transform: step >= 1 ? "scale(1)" : "scale(1.12)" }}
      />
      <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse at 50% 55%, rgba(5,8,20,0.25), rgba(5,8,20,0.85) 82%)" }} />

      {/* Dorothée rising / looking up from her book */}
      <img
        src={IMG.iaPortrait}
        alt="Dorothée IA"
        className="absolute bottom-0 left-1/2 -translate-x-1/2 h-[78%] object-contain transition-all duration-[1200ms]"
        style={{
          opacity: step >= 2 ? 1 : 0,
          transform: `translateX(-50%) translateY(${step >= 2 ? 0 : 50}px)`,
          maskImage: "linear-gradient(to bottom, black 82%, transparent 100%)",
          WebkitMaskImage: "linear-gradient(to bottom, black 82%, transparent 100%)",
          filter: "drop-shadow(0 20px 50px rgba(0,0,0,0.7))",
        }}
      />

      {/* Maine Coon crossing */}
      <img
        src={IMG.catWalking}
        alt=""
        className="absolute bottom-4 w-[130px] transition-all ease-linear"
        style={{
          left: step >= 3 ? "115vw" : "-18vw",
          transitionDuration: "6500ms",
          opacity: step >= 3 ? 1 : 0,
          maskImage: "radial-gradient(ellipse at 50% 55%, black 46%, transparent 78%)",
          WebkitMaskImage: "radial-gradient(ellipse at 50% 55%, black 46%, transparent 78%)",
          filter: "drop-shadow(0 10px 18px rgba(0,0,0,0.6))",
        }}
      />

      {/* Phrase + entry */}
      <div
        className="absolute inset-x-0 top-[16%] px-6 text-center transition-all duration-1000"
        style={{ opacity: step >= 4 ? 1 : 0, transform: step >= 4 ? "translateY(0)" : "translateY(20px)" }}
      >
        <div className="dl-eyebrow mb-5">Bienvenue</div>
        <p className="serif text-2xl sm:text-4xl lg:text-5xl text-[#F3E9D2] max-w-3xl mx-auto leading-tight">
          Vous êtes entré dans mon univers.<br />
          <span className="text-[#D4B978]">Par quelle porte voulez-vous commencer ?</span>
        </p>
        {step >= 4 && (
          <button data-testid="intro-enter-btn" onClick={dismiss} className="dl-btn dl-btn-solid mt-9">
            Entrer dans l'univers
          </button>
        )}
      </div>

      <button
        data-testid="intro-skip-btn"
        onClick={dismiss}
        className="absolute top-5 right-6 text-xs tracking-widest uppercase text-[#F3E9D2]/50 hover:text-[#D4B978] transition-colors"
      >
        Passer
      </button>
    </div>
  );
}
